<script>
    import { onMount, onDestroy } from "svelte";
    import { page, modal } from '../store/nav';
    import { items } from "../store/items";

    export let list_uid;
    export let store_logo;
    export let store_name;

    let redirectUrl;

    let ingredientList = {
        "ingredients": [],
        "saved": false,
        "recipeComposition": {
            "saved": false
        }
    };

    onMount(async ()=>{
        await items.init(list_uid, `listUid`);
        console.log(`1: ${list_uid}`);
        console.log($items);
    });

    const setIngredientList = async () => {
        $items.forEach(item => {
            console.log(item);
            let ingrTitle = [item.name];
            
            if ( item.cut ) ingrTitle.push(item.cut);

            item.options.forEach( option => {
                const kv = Object.entries(option);
                console.log(kv);
                if ( kv[0][1] ) ingrTitle.push(kv[0][0]); 
            });                
            
            if ( item.flavour ) ingrTitle.push(item.flavour);

            let ingredient = {
                "name": `${ingrTitle.join(" ")}`,
                /*"brand": ``,
                "asinOverrides": [],
                "componentIndex": 0,
                "quantityList": [
                    {
                    "unit": "OUNCES",
                    "amount": ${item.qty}
                    }
                ],
                */
                "exclusiveOverride": false
            };

            if ( item.qty ) {
                if ( item.unit ) {
                    ingredientList.quantityList = [
                        {
                            "unit" : item.unit,
                            "amount" : item.qty
                        }
                    ];
                } else {
                    ingredientList.quantityList = [
                        {
                            "unit" : "COUNT",
                            "amount" : item.qty
                        }
                    ];
                }
            }

            ingredientList.ingredients.push(ingredient);
        });
    };

    const setStore = () => {
        if ( store_name == "whole foods" ) return "VUZHIFdob2xlIEZvb2Rz"
        if ( store_name == "amazon fresh" ) return "QW1hem9uIEZyZXNo"
    };

    $: if( $items ){
        setIngredientList();
        let host = `https://shiny-butterfly-ea31.nico-javelaud1987.workers.dev`;
        console.log(`${host}?a=${setStore()}&p=${JSON.stringify(ingredientList)}`);
        redirectUrl = `${host}?a=${setStore()}&p=${encodeURIComponent(btoa(JSON.stringify(ingredientList)))}`
    };


</script>
<section >
    <div class="bg-primary absolute rounded-2xl w-12 h-12 shrink-0 top-5 right-5">
        <img class="m-auto w-8 h-8 mt-2" src="/img/stores/{store_logo}.png" alt="">
    </div>

    <section class="text-primary flex flex-col space-y-2">
        <span class="text-2xl capitalize font-bold">Online Fulfillment</span>
        <section class="flex flex-col space-y-3">
            <span class="text-sm mt-2">
                The link below will redirect you to <span class="capitalize">{store_name}</span>'s website. 
                <br/><u>You'll need to be logged in before being able to add the items in your cart.</u> 
                <br/>On the screen you'll also be able to swap or skip anything <span class="capitalize">{store_name}</span> found for you. 
                Once the items are added to your cart you can of course add more as you see fit.
                <br/>
                As an affiliate we might earn a commision when you purchase through that link at no extra cost for you.
            </span>
            <a target="_blank" href={redirectUrl} class="border border-secondary text-secondary bg-primary px-2 rounded-sm  min-w-16 capitalize text-sm italic place-self-center">Go to {store_name}</a>
        </section>
    </section>
</section>
<style lang="postcss">

</style>